/** @jsxImportSource @emotion/react */
import { useState } from 'react'
import { useDesignTokens } from '@hooks/useDesignTokens'
import { TOKENS } from '@gen/tokenConstants'
import CalendarNavigation from './CalendarNavigation'
import CalendarDisplay from './CalendarDisplay'
import { CalendarData, CalendarView } from '@/types/calendar'

interface CalendarBookingProps {
  calendarId: string
}

export default function CalendarBooking({ calendarId }: CalendarBookingProps) {
  const { getValue, getClasses } = useDesignTokens()
  const [currentDate, setCurrentDate] = useState(new Date())
  const [view, setView] = useState<CalendarView>('day')

  const mockCalendarData: CalendarData = {
    id: calendarId,
    name: `Calendar ${calendarId}`,
    events: [],
    timeSlots: generateTimeSlots(currentDate),
  }

  return (
    <div css={getClasses(TOKENS.layout.container.page)}>
      <div
        css={{
          backgroundColor: getValue(TOKENS.color.neutral[50]),
          borderRadius: getValue(TOKENS.borderRadius.lg),
          padding: 0,
          minHeight: '80vh',
          border: `1px solid ${getValue(TOKENS.color.primary[200])}`,
          boxShadow: `0 4px 6px -1px ${getValue(TOKENS.color.primary[200])}20`,
          overflow: 'hidden',
        }}
      >
        <CalendarNavigation
          currentDate={currentDate}
          onDateChange={setCurrentDate}
          view={view}
          onViewChange={setView}
        />
        <div css={{ padding: getValue(TOKENS.spacing.sm) }}>
          <CalendarDisplay
            calendarData={mockCalendarData}
            currentDate={currentDate}
            view={view}
          />
        </div>
      </div>
    </div>
  )
}

function generateTimeSlots(date: Date) {
  const slots = []
  const startTime = new Date(date)
  startTime.setHours(9, 0, 0, 0)

  for (let i = 0; i < 18; i++) {
    const start = new Date(startTime)
    start.setMinutes(startTime.getMinutes() + i * 30)

    const end = new Date(start)
    end.setMinutes(start.getMinutes() + 30)

    slots.push({
      id: `slot-${i}`,
      start,
      end,
      available: Math.random() > 0.3,
    })
  }

  return slots
}
